module.exports = __webpack_public_path__ + "media/components/assets/img/icons/loader-splash-f55ed1db88f70ee7b7627af03dca02ed.svg";